import React, { FC, useEffect, useState } from 'react'
import {
  ClbButton,
  ClbDropdown,
  ClbDropdownFooter,
  ClbDropdownItems,
  ClbDropdownTrigger,
  ClbLoading
} from '@celebration/react'
import { NxRadioGroup } from '../../../components/radio'
import { NxRadioGroupOption } from '../../../components/radio/types'
import { OptionContainer } from './styles/SelectProfile.styles'
import { UserRoles } from '../../auth/types'
import { useSelector } from 'react-redux'
import { RootState } from '../../../store/types'
import { useUsersApi } from '../hooks'
export interface IChangeProfileFormItems {
  role: string
}

const ProfileOptions: NxRadioGroupOption[] = [
  { id: 'Client', label: 'Perfil Cliente', value: UserRoles.Client },
  { id: 'Supplier', label: 'Perfil Transportador', value: UserRoles.Supplier },
  { id: 'Admin', label: 'Perfil Administrador', value: UserRoles.Admin }
]

const SelectProfile: FC = (): React.ReactElement => {
  const [isSelectProfileOpen, setIsSelectProfileOpen] = useState(false)
  const [selectedProfile, setSelectedProfile] = useState<string | undefined>(undefined)
  const { changeUserProfile, isLoading, } = useUsersApi()
  const roles = useSelector((state: RootState) => state.auth.user.info?.roles)

  useEffect(() => {
    if (roles && roles.length > 0) {
      const possibleRoles = [UserRoles.Admin, UserRoles.Supplier, UserRoles.Client];
      const userRole = possibleRoles.find(role => roles.includes(role));
      if (userRole) setSelectedProfile(userRole)
    }
  }, [roles])
  const handleChangeProfile = async () => {
    if (selectedProfile) {
      await changeUserProfile(selectedProfile)
      sessionStorage.setItem('profileChanged', 'true')
      window.location.replace('/')
    }
  }

  if (isLoading) {
    return <ClbLoading />
  }
  return (
    <ClbDropdown dropdownPosition='left' >
      <ClbDropdownTrigger >
        <ClbButton
          aria-label='Selecionar Perfil'
          icon={'user'}
          onClick={() => setIsSelectProfileOpen(!isSelectProfileOpen)}
          styleType='icon'
          size='md' />
      </ClbDropdownTrigger>
      <ClbDropdownItems >
        <OptionContainer>
          <NxRadioGroup
            options={ProfileOptions}
            value={selectedProfile}
            onChange={setSelectedProfile}
            stopPropagation />
        </OptionContainer>
      </ClbDropdownItems>
      <ClbDropdownFooter>
        <ClbButton
          styleType='secondary'
          size='md'
          onClick={() => setIsSelectProfileOpen(false)}
          label='Cancelar'
          aria-label='Cancelar'
        />
        <ClbButton
          styleType='primary'
          size='md'
          label='Salvar'
          onClick={handleChangeProfile}
          loading={isLoading}
          aria-label='Salvar'
        />
      </ClbDropdownFooter>
    </ClbDropdown>
  )
}
export default SelectProfile
